


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbView, mdbMask } from '@folky-tools/mdbvue';
import { Business } from '@/models/businesses/business';
import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbView,
        mdbMask
    }
})
export default class BusinessProductDeliverySummary extends Vue {
    @Prop(Business) private business!: Business;
    @Prop(BusinessSellingOptions) private businessSellingOptions!: BusinessSellingOptions;
    @Prop({ type: Boolean, default: false }) private pageContentLoaded?: boolean;
}
